import {AfterViewInit, Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {first, pairwise, startWith} from "rxjs/operators";
import {CoreService} from "../../../../../services/core/core.service";
import {CustomerCreateEditComponent} from "../../../../customer/customer-create-edit/customer-create-edit.component";
import {DialogService} from "../../../../../services/core/dialog.service";
import {
  CreateEditCustomerContactComponent
} from "../../../../customer-contact/create-edit-customer-contact/create-edit-customer-contact.component";
import {SharedService} from "../../../../shared/shared.service";
import {Subscription} from "rxjs";
import { NotOnlySpaces } from '../../../../shared/CustomValidators/CustomNotOnlySpacesValidator';
import { SubofficeService } from 'src/app/modules/setting/company-settings/suboffice/suboffice.service';



@Component({
    selector: 'app-bid-detail-form',
    templateUrl: './bid-detail-form.component.html',
    styleUrls: ['./bid-detail-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BidDetailFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => BidDetailFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class BidDetailFormComponent implements OnInit, AfterViewInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Input() isEdit: boolean = false;
  @Output() callback = new EventEmitter<any>(true);
// These fields are only relevant when user create bid from bid selection pop up of the proposal
  @Input() DefaultCustomerId: string = '';
  @Input() DefaultContactId: string = '';
  @Input() defaultDate: Date | null = null;
  @Input() defaultTime: Date | null = null;
  @Input() isFromCalendar: boolean = false;
  @Input() isCellClick: boolean = false; // Add cell click flag

  public customers:any[]=[];
  public contacts:any[]=[];
  public allCustomers:any[] = [];
  public isFormTouched = false;
  //@ts-ignore
  public bidDetailFormSubscription: Subscription;

  public bidDetailForm: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl(null,[Validators.required,NotOnlySpaces()]),
    building_specifications: new UntypedFormControl(null),
    customer: new UntypedFormControl(null),
    startTime: new UntypedFormControl(null,[Validators.required]),
    due_date_at: new UntypedFormControl(null,[Validators.required]),
    tenant_id:new UntypedFormControl('',[Validators.required,NotOnlySpaces()]),
    tenant_ids:new UntypedFormControl(null)
  });

  constructor(
    public sharedService: SharedService,
    public coreService: CoreService,
    public dialogService: DialogService,
    public subofficeService: SubofficeService
  ) { }


  ngOnInit(): void {

    this.initSubscriptions();
    this.setDataOnEdit();
    if(this.isFromCalendar){
      this.setDefaultValues();
    } else if (!this.isEdit) {
      this.setCreateDefaults();
    }


    if(this.isEdit) {
      this.bidDetailForm?.removeControl('customer');
    }else {
      // this.getCustomers();
    }
  }

  ngAfterViewInit(): void {
  }

  // Add new method to set default values
  setDefaultValues(): void {
    if (!this.isEdit && this.isFromCalendar) {  
      // Always set the date
      const dateToSet = this.defaultDate || new Date();
      console.log('Setting date to:', dateToSet);
      this.bidDetailForm?.get('due_date_at')?.setValue(dateToSet);
      
      // Set time based on source
      if (this.isCellClick) {
        // For cell click, use the provided time or default to 12:00 AM
        const timeToSet = this.defaultTime || this.createDefaultTime();
        this.bidDetailForm?.get('startTime')?.setValue(timeToSet);
      } else {
        // For Create button, always use 12:00 AM
        const timeToSet = this.createDefaultTime();
        this.bidDetailForm?.get('startTime')?.setValue(timeToSet);
      }
    } 
  }

  // Helper method to create default time (12:00 AM)
  createDefaultTime(): Date {
    const defaultTime = new Date();
    defaultTime.setHours(0, 0, 0, 0); // 12:00 AM
    return defaultTime;
  }

  // Sets today's date and 12:00 PM as defaults for new bid creation
  setCreateDefaults(): void {
    this.bidDetailForm?.get('due_date_at')?.setValue(new Date());
    const noon = new Date();
    noon.setHours(12, 0, 0, 0); // 12:00 PM
    this.bidDetailForm?.get('startTime')?.setValue(noon);
  }

  setDataOnEdit = () => {
    if(this.isEdit) {
      /*this.bidDetailForm?.get('name')?.setValue(this.model?.name);
      this.bidDetailForm?.get('due_date_at')?.setValue(this.coreService.toDateParse(this.model?.due_date_at));*/
      this.bidDetailForm?.setValue({
        name: this.model?.name,
        building_specifications: this.model?.building_specifications ?? null,
        due_date_at: this.coreService.toDateParse(this.model?.due_date_at_y_m_d),
        startTime: this.model?.due_time ? this.parseTimeString(this.model.due_time) : null,
        customer: "",
        tenant_id: '',
        tenant_ids: []
      });
    }
  }

  parseTimeString(timeString: string): Date | null {
    if (!timeString) return null;
    const str = String(timeString).trim();

    // Support "02:00:AM" or "02:00 AM"
    let m = str.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*([AP]M)$/i);
    if (!m) {
      // handle "02:00:AM" (colon before AM/PM)
      const m2 = str.match(/^(\d{1,2}):(\d{2})(?::([AP]M))$/i);
      if (m2) m = [m2[0], m2[1], m2[2], '', m2[3]];
    }
    if (m) {
      let h = parseInt(m[1], 10);
      const min = parseInt(m[2], 10);
      const s = m[3] ? parseInt(m[3], 10) : 0;
      const mer = (m[4] || '').toUpperCase();
      if (mer === 'PM' && h < 12) h += 12;
      if (mer === 'AM' && h === 12) h = 0;
      const d = new Date();
      d.setHours(h, min, s, 0);
      return d;
    }

    // Fallback: "HH:MM:SS" or "HH:MM"
    const hms = str.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))$/);
    if (hms) {
      const d = new Date();
      d.setHours(parseInt(hms[1],10), parseInt(hms[2],10), parseInt(hms[3],10), 0);
      return d;
    }
    const hm = str.match(/^(\d{1,2}):(\d{2})$/);
    if (hm) {
      const d = new Date();
      d.setHours(parseInt(hm[1],10), parseInt(hm[2],10), 0, 0);
      return d;
    }

    return null;
  }

  onCreateCustomer(): void {
    this.dialogService.onOpenDialog(CustomerCreateEditComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      this.getCustomers();
    });
  }

  onCreateContact(): void {
    this.dialogService.onOpenDialog(CreateEditCustomerContactComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      this.getCustomers();
    });
  }

  onChangeCustomer = (event:any) => {
    console.log('onChangeCustomer', event);
    // this.bidDetailForm.get('contact_id')?.setValue(null);
    // let customer = this.getCustomerByID(event?.id);
    // this.contacts = customer?.contacts;
    // this.contacts = this.contacts.map((customer:any)=>{
    //   return {id: customer.id, name: customer.full_name};
    // });
  }

  getCustomerByID = (customerID:any) => {
    let customer = this.allCustomers.filter((customer: any)=>{
      return customerID === customer.id;
    });
    return (customer.length > 0) ? customer[0] : [];
  }

  getCustomers = () => {
    this.sharedService.getCustomers()
      .pipe(first())
      .subscribe(
        (data:any) => {
          this.allCustomers = data.data;
          this.customers = this.allCustomers.map((customer:any)=>{
            return {id: customer.id, name: customer.company_name};
          });
        });
  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.bidDetailForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.bidDetailForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.bidDetailForm.disable() : this.bidDetailForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.bidDetailForm.valid ? null : { invalidForm: {valid: false, message: "Company name fields are invalid"}};
  }

  initSubscriptions(){
    if (this.form){
      this.bidDetailFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched && !this.isFormTouched){
            this.isFormTouched = true;
            this.touchFormControls();
            this?.bidDetailForm.get('customer')?.updateValueAndValidity({ onlySelf: false, emitEvent: true });

          }
        });
    }

  }
  touchFormControls(){
    Object.keys(this.bidDetailForm.controls).forEach(key => {
      this.bidDetailForm.get(key)?.markAsTouched();
    });
  }
  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.bidDetailFormSubscription?.unsubscribe();
  }

  changeOfficeSelection(event:any){
    this.bidDetailForm.get('tenant_id')?.setValue(event.current_tenent);
    this.bidDetailForm.get('tenant_ids')?.setValue(event.select_tenents);
    this.subofficeService.updateTenantId(event.current_tenent);
  }

}
